import { useMsal } from "@azure/msal-react";


export const AccessToken = () => {    
    
    const { instance, accounts } = useMsal();
    
    const accessTokenRequest:any = {
        scopes: ["api://a78f5d2a-b382-4d41-99eb-89f92d896a9b/user_auth"],
        account: accounts[0],
    };
    
    return [instance, accessTokenRequest]
}
